// extracted by mini-css-extract-plugin
export default {"factor":"uom-conversion__factor--ZQeeN","loader":"uom-conversion__loader--arvTK"};